import { createVanIconComponent } from "./van"

const ChatOutlined = createVanIconComponent("chat-o")
export default ChatOutlined
